import {Component, ElementRef, EventEmitter, forwardRef, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild} from '@angular/core';
import {ControlValueAccessor, FormBuilder, FormGroup, NG_VALUE_ACCESSOR, Validators} from '@angular/forms';

@Component({
  selector: 'app-concat',
  templateUrl: './concat.component.html',
  styleUrls: ['./concat.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef( () => ConcatComponent),
      multi: true
    }
  ]
})
export class ConcatComponent implements OnInit, ControlValueAccessor, OnChanges {

  /*@Input() concat: string;*/
  @Input() data: any[];
  @Output() emitter = new EventEmitter<any[]>();
  @ViewChild('editorText') editText: ElementRef;
  form: FormGroup;
  options: any[] = [];
  constructor(
    protected fb: FormBuilder
  ) {
    this.form = fb.group({
      'text': ['', Validators.required]
    });
    this.form.valueChanges.subscribe(val => {
      this.propagateChange(val);
    });
  }

  propagateChange = (_: any) => {};
  ngOnInit() {
  }


  replaceFunction(field) {
    const start = this.editText.nativeElement.selectionStart;
    const end = this.editText.nativeElement.selectionEnd;
    const replaceText = this.form.controls['text'].value.substring(start, end);
    const value = this.form.controls['text'].value;
    if (start !== end) {
      field = this.assignSpace(field, start, end, value);
      this.form.controls['text'].setValue(this.form.controls['text'].value.substring(0, start) +
        field + this.form.controls['text'].value.substring(end));
    } else {
      this.form.controls['text'].setValue(this.form.controls['text'].value + '@' + field + ' ');
    }
  }

  checkEndSpace(value, end): boolean {
    return value.substring(end - 1, end) === ' ';
  }

  checkEndKey(value, end): boolean {
    return value.substring(end, end + 1) === '}';
  }

  checkInitKey(value, start): boolean {
    return value.substring(start - 1, start) === '@';
  }

  assignSpace(field, start, end, value): string {
    if (this.checkInitKey(value, start)) {
      return field + ' ';
    }
    if (!this.checkInitKey(value, start) && this.checkEndSpace(value, end)) {
      return '@' + field + ' ';
    } else {
      return '@' + field;
    }
  }

  save() {
    this.emitter.emit(this.form.value);
  }

  registerOnChange(fn: any): void {
    this.propagateChange = fn;
  }

  registerOnTouched(fn: any): void {
  }

  setDisabledState(isDisabled: boolean): void {
  }

  writeValue(obj: any): void {
  }

  ngOnChanges(changes: SimpleChanges): void {
      if (changes['data'].currentValue) {
        if (typeof this.data[0] === 'number') {
          this.data.forEach( (val, i) => {
            this.data[i] = String(val);
          });
        }
      }
  }

}



// WEBPACK FOOTER //
// ./src/app/pages/import-template/component/concat/concat.component.ts